import {
    formatDistanceFromKm,
    useLocalisation,
} from '@archipro-website/localisation';

/**
 * Returns a formatter for canonical kilometre distances using the active market locale.
 */
export const useFormatDistance = (): ((distanceKm: number) => string) => {
    const { countryConfig, locales } = useLocalisation();

    return (distanceKm: number) =>
        formatDistanceFromKm(distanceKm, {
            measurementSystem: countryConfig.measurementSystem,
            locale: locales[0],
        });
};
